import AppShell from "./AppShell";
import { getApp } from "@/lib/apps";

const Openlynq = () => <AppShell app={getApp("openlynq")} />;

export default Openlynq;
